
import HeaderMenuLeftDropdown from "./HeaderMenuLeftDropdown";
import {mapMutations} from "vuex";
import {catalogMenuSections} from "../utils/catalogMenu";
export default {
    components: {HeaderMenuLeftDropdown},
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    computed: {
        menuCatalog(){
            return catalogMenuSections;
        },
        menuCatalogState () {
            return this.$store.state.dropdownMenu.catalog
        },
    },
    methods: {
        ...mapMutations({
            toggleCatalog: 'toggleDropdownMenuCatalog',
            closeCatalog: 'closeDropdownMenuCatalog',
        }),
        closeDropdowns() {
            this.closeCatalog();
        },
        handleKeydown(event) {
            if (event.key === 'Escape' && this.menuCatalogState) {
                this.closeDropdowns();
            }
        },
    },
}
